export default (state, loadingValue) => {
    state.postListIsLoading = loadingValue
}
